import React from 'react'
import { Loader, White, Blue } from './LoadingStyled'
import { ReactComponent as WhiteSvg } from './svg/white.svg'
import { ReactComponent as BlueSvg } from './svg/blue.svg'
import Container from '../container/AppContainer'
interface LOADER_PROPS {
  duration: number
}
export default function Loading({ duration }: LOADER_PROPS) {
  return (
    <Container color='#050423'>
      <Loader>
        <White>
          <WhiteSvg />
        </White>
        <Blue duration={duration}>
          <BlueSvg />
        </Blue>
      </Loader>
    </Container>
  )
}
